module.exports = __webpack_public_path__ + "static/media/030dadd9-1b96-4e5d-8aba-581d4c814565-removebg-preview.fdec9007.png";